module.exports = __webpack_public_path__ + "img/41_44.c6a1eae6.png";